import { apiRequest } from './api';

const TOKEN_KEY = 'pensionAdminToken';

/* ─────────────────────────────────────────────
 * 공개 API — 개인정보 없음. 메인 달력이 사용합니다.
 * ───────────────────────────────────────────── */

/**
 * 특정 월의 객실별 예약 현황.
 * @returns {Promise<{year:number, month:number, rooms:string[], booked:Object<string,string[]>}>}
 *          booked: { '2026-08-02': ['단풍','이팝'] } — 그 날 밤에 이미 찬 객실 목록
 */
export const fetchAvailability = (year, month, signal) =>
    apiRequest('/pension/availability', 'GET', { year, month }, { signal });

/* ─────────────────────────────────────────────
 * 관리자 API — 토큰 필수
 * ───────────────────────────────────────────── */

export const adminLogin = async (password) => {
    const res = await apiRequest('/pension/admin/login', 'POST', { password });
    if (res && res.token) sessionStorage.setItem(TOKEN_KEY, res.token);
    return res;
};

export const getAdminToken = () => sessionStorage.getItem(TOKEN_KEY);
export const clearAdminToken = () => sessionStorage.removeItem(TOKEN_KEY);

const withToken = (extra = {}) => ({ token: getAdminToken(), ...extra });

/** 해당 월의 예약 목록 (예약자명·연락처 포함) */
export const fetchReservations = (year, month, signal) =>
    apiRequest('/pension/reservations', 'GET', { year, month }, withToken({ signal }));

export const createReservation = (payload) =>
    apiRequest('/pension/reservations', 'POST', payload, withToken());

export const updateReservation = (id, payload) =>
    apiRequest(`/pension/reservations/${id}`, 'PUT', payload, withToken());

export const deleteReservation = (id) =>
    apiRequest(`/pension/reservations/${id}`, 'DELETE', null, withToken());